import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout do módulo Investidores/RI (Portal Vega, Bloco 2 — ADR-0013). Só monta o <Outlet/>; abas
 * filhas: ri.investidores.tsx (Potenciais Investidores, Fatia A). /ri (bare) redireciona para
 * /ri/investidores via ri.index.tsx — mesma convenção de pipeline.tsx/portfolio.tsx (DEC-060).
 */
export const Route = createFileRoute('/ri')({
  component: () => <Outlet />,
});
